export default defineNuxtRouteMiddleware(function paramsGlobalMiddleware(to) {
  // TODO: Move to plugin setup for server and router.beforeEach() for client, when all dependant stores are migrated

  const params = useParams()
  params._init(to.query)
  useFlexTrip().init(params.all)
})
